<template>
    <button class="btn btn-info" :class="btnClass" :disabled="poster.submitted" @click="posterPost()">
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        manager: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/managers/' + this.manager.id + '/disableAccount'
        }
    },

    methods: {
        posterSuccess (data) {
            if (this.manager.disabled_at) {
                bus.$emit(
                    'notify',
                    'Kontot har återaktiverats'
                )
            } else {
                bus.$emit(
                    'notify',
                    'Kontot har inaktiverats'
                )
            }
            this.$emit('success')
        }
    }
}
</script>
